import { useNavigate } from 'react-router-dom';
import { useProjectForm } from '../../context/ProjectFormContext';
import { FiArrowRight } from 'react-icons/fi';
import Seo from '../../components/seo';
import Layout from '../../components/layout';
import Header from '../../components/header';
import Footer from '../../components/footer';

/**
 * ProjectThanks
 * Thank you page after successful project request submission
 */
const ProjectThanks = () => {
  const navigate = useNavigate();
  const { formData, resetForm } = useProjectForm();

  const handleBackHome = () => {
    resetForm();
    navigate('/');
  };

  const handleNewProject = () => {
    resetForm();
    navigate('/contact');
  };

  return (
    <Layout classmain="project-thanks-page">
      <Seo
        title="Thank You - Bercastle"
        metaDesciption="Thank you for submitting your project request. We'll be in touch shortly to discuss your vision."
      />
      <Header />

      {/* Content */}
      <main className="pt-24 md:pt-52 pb-24">
        <div className="container-custom max-w-4xl mx-auto text-center space-y-12">
          {/* Main Thank You Message */}
          <div className="space-y-8">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-black leading-tight">
              Thank you{formData.name ? `, ${formData.name}` : ''}
              <span className="text-[#d6fa70]">.</span>
            </h1>
            <p className="text-xl md:text-2xl text-slate-600 leading-relaxed max-w-2xl mx-auto">
              We've received your project request and will be in touch shortly to discuss your vision.
            </p>
          </div>

          {/* Details Summary */}
          {(formData.email || formData.company) && (
            <div className="bg-slate-50 rounded-3xl p-8 md:p-12 space-y-6 text-left inline-block">
              <div className="grid md:grid-cols-2 gap-8">
                {formData.email && (
                  <div>
                    <p className="text-sm text-slate-500 font-semibold uppercase tracking-wide mb-2">
                      Email
                    </p>
                    <p className="text-lg text-slate-900">{formData.email}</p>
                  </div>
                )}
                {formData.company && (
                  <div>
                    <p className="text-sm text-slate-500 font-semibold uppercase tracking-wide mb-2">
                      Company
                    </p>
                    <p className="text-lg text-slate-900">{formData.company}</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <button
              onClick={handleBackHome}
              className="px-8 py-4 rounded-full border border-slate-300 text-slate-900 font-semibold hover:border-slate-400 hover:bg-slate-50 transition-colors"
            >
              Back to Home
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </Layout>
  );
};

export default ProjectThanks;
